import React, { useEffect, useState, useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useSelector, useDispatch } from "react-redux";
import { getUserActivity } from "../../features/user/userSlice";
import {
  deleteMeeting,
  extractMeetingTasks,
  getMeeting,
  updateMeeting,
} from "../../features/meetings/meetingsSlice";
// import { executeTask, getTaskOptions } from "../../features/tasks/taskSlice";
import { useNavigate, useParams } from "react-router-dom";
// import {
//   deleteTask,
//   getTask,
//   updateTask,
// } from "../../features/tasks/taskSlice";
import { Icons } from "../../constants/icon-library";
import { toast } from "react-toastify";
import { initializePageData, createMeetingHandlers } from "./Meetings.utils";

import AddTaskModal from "./AddTaskModal";
import TranscriptModal from "./TranscriptModal";
import RegenerateModal from "./RegenerateModal";
import MeetingHeader from "./MeetingHeader";
import MeetingSummaryCard from "./MeetingSummaryCard";
import TaskList from "../Tasks/Task";
import { fetchSettingDetailsByUserId } from "../../features/settings/settingsSlice";
import LoadingComponent from "../../components/common/LoadingComponent";
import { confirmationModal } from "../../constants/confirmation.constants";
import { getParticipants } from "../../features/participant/participantSlice";
import SummaryModal from "./SummaryModal";
import ParticipantsModal from "./ParticipantsModal";
import TimeZoneModal from "./TimeZoneModal";

const MeetingDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showTranscriptModal, setShowTranscriptModal] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [showRegenerateModal, setShowRegenerateModal] = useState(false);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [editedTaskName, setEditedTaskName] = useState("");
  const [editedTaskDescription, setEditedTaskDescription] = useState("");

  const { user } = useSelector((state) => state.user);
  const { meeting } = useSelector((state) => state.meetings);
  const { task } = useSelector((state) => state.task);
  const { userSettings } = useSelector((state) => state.setting);

  const [executingTaskIds, setExecutingTaskIds] = useState(new Set());

  const [isExtracting, setIsExtracting] = useState(false);
  const { meetingId } = useParams();

  const modalRef = useRef();
  const participants = meeting?.participants || [];

  const { participants: allParticipants = [] } = useSelector(
    (state) => state.participants,
  );

  useEffect(() => {
    dispatch(fetchSettingDetailsByUserId());
    dispatch(getParticipants());
    initializePageData(dispatch, meetingId, {
      getUserActivity,
      getMeeting,
      // getTask,
    });
  }, [dispatch, meetingId]);

  const handleTaskUpdate = async (uuid, payload) => {
    try {
      // await dispatch(
      //   updateTask({
      //     uuid,
      //     meetingId,
      //     ...payload,
      //   }),
      // ).unwrap();
      toast.success("Task updated successfully");
    } catch (err) {
      toast.error("Failed to update task");
    }
  };

  const handleMeetingUpdate = async (title) => {
    try {
      await dispatch(
        updateMeeting({
          meetingId: meetingId,
          title,
        }),
      );
      toast.success("Meeting Update Successfully");
    } catch (err) {
      toast.error("Failed to update Meeting");
    }
  };

  const handleExtractTasks = async () => {
    try {
      setIsExtracting(true);
      await dispatch(extractMeetingTasks({ meetingId })).unwrap();
    } catch (err) {
      setIsExtracting(false);
      toast.error("Failed to extract tasks");
    }
  };

  const handleExecute = async (actionIds) => {
    try {
      await handleSend(actionIds, meetingId);
    } catch (err) {
      console.error(err);
    }
  };
  const handleDelete = async (meetingId) => {
    const result = await confirmationModal(
      "Are you sure?",
      "This will delete it permanently.",
    );
    if (result.isConfirmed) {
      try {
        await dispatch(deleteMeeting(meetingId)).unwrap();
        toast.success("Task removed successfully.");
        navigate("/meetings");
      } catch (error) {
        toast.error("Failed to delete meeting");
      }
    }
  };

  useEffect(() => {
    if (meeting?.status === "PROCESSING_TASKS") {
      setIsExtracting(false);
    }
  }, [meeting?.status]);

  const {
    handleSend,
    handleAddTask,
    handleRegenerate,
    handleShowSummary,
    handleShowTranscript,
    handleShowParticipants,
    handleHideAddModal,
    handleHideSummaryModal,
    handleHideTranscriptModal,
    handleHideParticipantsModal,
    handleHideRegenerateModal,
    handleToggleAll,
    handleToggleTask,
    handleTogglePlatformTask,
    handleShowRegenerate,
  } = createMeetingHandlers({
    dispatch,
    meetingId,
    meeting,
    task,
    user,
    modalRef,
    // updateTask,
    setSelectedTasks,
    setShowAddModal,
    setShowSummaryModal,
    setShowTranscriptModal,
    setShowParticipantsModal,
    setShowRegenerateModal,
    selectedTasks,
    // executeTask,
    setExecutingTaskIds,
  });

  const handleStartEdit = (taskItem) => {
    setEditingTaskId(taskItem.uuid);
    setEditedTaskName(taskItem.name);
    setEditedTaskDescription(taskItem.description);
  };

  const handleCancelEdit = () => {
    setEditingTaskId(null);
    setEditedTaskName("");
    setEditedTaskDescription("");
  };

  const handleSaveEdit = async (taskItem) => {
    const taskName = editedTaskName.trim();
    const description = editedTaskDescription.trim();
    if (!taskName || description.length < 10) return;

    // await dispatch(
    //   updateTask({
    //     uuid: taskItem.uuid,
    //     meetingId: meeting?.uuid,
    //     status: taskItem.status,
    //     name: taskName,
    //     description,
    //   }),
    // );

    setEditingTaskId(null);
    setEditedTaskName("");
    setEditedTaskDescription("");
  };

  const handleParticipantsSave = async (participantUUIDs) => {
    try {
      await dispatch(
        updateMeeting({
          meetingId: meetingId,
          participants: participantUUIDs,
        }),
      ).unwrap();

      toast.success("Participants updated successfully");
      if (task?.actions?.length) {
        task.actions.forEach((action) => {
          // const setting = userSettings.find((s) => s.uuid === action.settingId);
          // const platformType = setting?.assistantId?.platform?.type;
          // if (platformType && action.settingId) {
          //   dispatch(
          //     getTaskOptions({
          //       settingId: action.settingId,
          //       platformType,
          //       meetingId,
          //     }),
          //   );
          // }
        });
      }
    } catch (err) {
      toast.error("Failed to update participants");
    }
  };

  const handleDeleteTask = async (taskItem) => {
    if (!meeting?.uuid || !taskItem?.uuid) return;
    const result = await confirmationModal(
      "Are you sure?",
      "This will delete it permanently.",
    );
    if (result.isConfirmed) {
      try {
        // await dispatch(
        //   deleteTask({
        //     taskId: taskItem.uuid,
        //     meetingId: meeting.uuid,
        //   }),
        // );
        toast.success("Task removed successfully.");
      } catch {
        toast.error("Failed to remove task.");
      }
    }
  };

  const handleKeyDown = (e, taskItem) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSaveEdit(taskItem);
    } else if (e.key === "Escape") {
      handleCancelEdit();
    }
  };

  const handleTimezoneSave = async (timezone) => {
    try {
      const res = await dispatch(
        updateMeeting({
          meetingId: meeting.uuid,
          timezone,
        }),
      );

      if (res.payload?.uuid) {
        toast.success("Meeting timezone updated");

        document.activeElement?.blur();

        const closeBtn = document.querySelector(
          "#meetingTimezoneModal .btn-close",
        );

        closeBtn?.click();
      } else {
        toast.error(res.payload?.message || "Failed to update timezone");
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update timezone");
    }
  };

  if (
    meeting?.status === "PROCESSING" ||
    meeting?.status === "PROCESSING_TASKS" ||
    isExtracting
  ) {
    const isProcessingTasks =
      meeting?.status === "PENDING" || "PROCESSING_TASKS";
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "80vh" }}
      >
        <div
          className="card  position-relative overflow-hidden"
          style={{ width: "680px", borderRadius: "14px" }}
        >
          <button
            className="btn btn-primary btn-sm position-absolute"
            style={{ top: "12px", right: "12px", zIndex: 1 }}
            onClick={() => window.location.reload()}
          >
            <i className={`wb ${Icons("load")} me-2`} />
            Refresh
          </button>

          <div className="card-body text-center p-5">
            <div className="mb-4 mt-2 d-flex justify-content-center">
              <LoadingComponent loading={true} />
            </div>

            <h4 className="fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
              <i
                className={`wb ${Icons("meeting")} fs-7 text-primary align-middle`}
              />
              <span className="text-primary">
                {isProcessingTasks
                  ? `Finalizing ${meeting?.title || "your meeting"}`
                  : `Analyzing ${meeting?.title || "your meeting"}`}
              </span>
            </h4>

            <p className="mb-4" style={{ opacity: 0.8 }}>
              {isProcessingTasks
                ? "Preparing structured insights and actionable outcomes."
                : "Extracting insights, identifying key points, and building your summary."}
            </p>

            <div className="summary-box px-5 py-3 mx-auto">
              <p className="text-body  mb-0">
                {meeting?.transcript
                  ? meeting.transcript.length > 200
                    ? meeting.transcript.substring(0, 200) + "..."
                    : meeting.transcript
                  : "Processing your meeting data..."}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!meeting || meeting.uuid !== meetingId) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <LoadingComponent loading={true} size={15} />
      </div>
    );
  }

  return (
    <div
      className="content"
      style={{ maxWidth: "100%", padding: "4px 20px", marginTop: "40px" }}
    >
      <div className="pb-5 pt-3">
        <MeetingHeader
          user={user}
          meeting={meeting}
          onShowParticipants={handleShowParticipants}
          onShowSummary={handleShowSummary}
          onShowTranscript={handleShowTranscript}
          onDelete={handleDelete}
          onRename={handleMeetingUpdate}
        />

        {/* Summary Section */}
        <div className="bg-body-emphasis rounded-3 p-4 mb-4 border">
          <MeetingSummaryCard meeting={meeting} />
        </div>

        {/* Task Section */}
        <div className="bg-body-emphasis rounded-3 p-4 border">
          <div className="d-flex mb-3 align-items-center justify-content-between">
            <div className="d-flex align-items-center ">
              <h3 className="mb-0 d-flex align-items-center gap-2">
                <i className="bi bi-list-check" />
                Tasks ({task?.actions.length || 0})
              </h3>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-2">
              <button
                className="btn btn-primary btn-sm"
                onClick={handleShowRegenerate}
              >
                <i className={`wb ${Icons("rework")} me-2`} />
                Regenerate Task
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={handleAddTask}
              >
                <i className="bi bi-plus-lg me-1" />
                Add Task
              </button>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 mb-2">
            <input
              type="checkbox"
              checked={
                task?.actions?.length > 0 &&
                selectedTasks.length === task.actions.length
              }
              onChange={() => handleToggleAll()}
              className="form-check-input m-0"
            />
            <h5 className="mb-0">Select All</h5>
          </div>

          {meeting?.status === "PENDING" ? (
            <div className="d-flex justify-content-center align-items-center py-3">
              <button
                className="btn btn-primary btn-lg d-flex align-items-center gap-2"
                onClick={() => handleExtractTasks(meetingId)}
              >
                <i className={`wb ${Icons("resume")} align-middle`} />
                ExtractTasks
              </button>
            </div>
          ) : (
            <TaskList
              actions={task?.actions}
              selectedTasks={selectedTasks}
              editingTaskId={editingTaskId}
              editedTaskName={editedTaskName}
              editedTaskDescription={editedTaskDescription}
              onStartEdit={handleStartEdit}
              onCancelEdit={handleCancelEdit}
              onSaveEdit={handleSaveEdit}
              onDeleteTask={handleDeleteTask}
              onKeyDown={handleKeyDown}
              onTaskNameChange={setEditedTaskName}
              onDescriptionChange={setEditedTaskDescription}
              onSend={handleExecute}
              settings={userSettings}
              onToggleTask={handleToggleTask}
              onTogglePlatformTask={handleTogglePlatformTask}
              onToggleAll={handleToggleAll}
              handleToggleAll={handleToggleAll}
              participants={participants}
              onTaskUpdate={handleTaskUpdate}
              executingTaskIds={executingTaskIds}
              meeting={meeting}
            />
          )}
        </div>
      </div>

      <AddTaskModal
        show={showAddModal}
        onHide={handleHideAddModal}
        meeting={meeting}
        task={task}
        settings={userSettings}
        participants={participants}
      />

      <ParticipantsModal
        show={showParticipantsModal}
        onHide={handleHideParticipantsModal}
        participants={participants}
        allParticipants={allParticipants}
        onSave={handleParticipantsSave}
        settings={userSettings}
      />

      <TimeZoneModal meeting={meeting} onSave={handleTimezoneSave} />

      <TranscriptModal
        show={showTranscriptModal}
        onHide={handleHideTranscriptModal}
        meeting={meeting}
      />

      <SummaryModal
        show={showSummaryModal}
        onHide={handleHideSummaryModal}
        meeting={meeting}
      />

      <RegenerateModal
        show={showRegenerateModal}
        onHide={handleHideRegenerateModal}
        onConfirm={handleRegenerate}
        meeting={meeting}
      />

      {selectedTasks?.length > 0 && (
        <div className="execute-bar bg-body-emphasis border-top border-translucent shadow-lg">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-end py-3 px-3">
              <button
                className="btn btn-primary btn-sm execute-bar__btn"
                disabled={!meeting?.agent?.settingIds?.length}
                onClick={() => handleExecute(selectedTasks)}
              >
                <i className={`wb ${Icons("resume")} me-1 align-middle`} />
                Execute
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeetingDetails;
